
    const Dashboard = ({ user, stats, jobSeekers }) => (
      <div className="p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Welcome, {user?.fullName}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div className="bg-orange-100 p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-gray-700">Total JobSeekers</h3>
            <p className="text-2xl text-orange-500">{stats?.totalJobSeekers || 0}</p>
          </div>
          <div className="bg-orange-100 p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-gray-700">Total Jobs Assigned</h3>
            <p className="text-2xl text-orange-500">{stats?.totalJobsAssigned || 0}</p>
          </div>
        </div>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Recent JobSeekers</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="p-2 text-left">Name</th>
                <th className="p-2 text-left">Email</th>
                <th className="p-2 text-left">Jobs Assigned</th>
              </tr>
            </thead>
            <tbody>
              {jobSeekers?.map(jobSeeker => (
                <tr key={jobSeeker._id} className="border-b border-gray-200">
                  <td className="p-2">{jobSeeker.firstName} {jobSeeker.lastName}</td>
                  <td className="p-2">{jobSeeker.email}</td>
                  <td className="p-2">{jobSeeker.totalJobs}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );



export default Dashboard;